/**
 * Tile Image Mapping
 * 
 * Maps tile constants to image paths for rendering.
 * Based on Flash Embed mappings from louo.as
 */

import {
    WALL, TOWN_HALL, DEEP_WATER, WATER, LAND,
    WOOD, CUTTER, SAWMILL, CUTTER_OLD,
    STONE, QUARRY, STONEMASON, QUARRY_OLD,
    IRON, MINE, FOUNDRY, MINE_OLD,
    FOOD, OPEN, FARM, MILL, LAKE, FARM_OLD,
    GOLD, MANOR, BAZAAR, WHARF,
    CASA, CELLARIUM, CACHE,
    SHIPYARD, BARRACKS, CASTLE, CITY_GUARD_HOUSE,
    MOONGLOW, STABLES, TEMPLE, TRAINING_GROUND, WORKSHOP
} from '../core/Constants.js';

/**
 * Map tile constants to image asset keys
 * These keys are used with AssetLoader to get the actual image paths
 */
export const TILE_IMAGE_MAP = {
    // Terrain
    [WALL]: null, // Don't render walls
    [TOWN_HALL]: 'building_townhall',
    [DEEP_WATER]: null,
    [WATER]: null, // Use background
    [LAND]: null, // Use background
    
    // Wood resources and buildings
    [WOOD]: 'resource_forest',
    [CUTTER]: 'building_forester',
    [SAWMILL]: 'building_sawmill',
    [CUTTER_OLD]: 'building_forester',
    
    // Stone resources and buildings
    [STONE]: 'resource_stones',
    [QUARRY]: 'building_quarry',
    [STONEMASON]: 'building_stonemason',
    [QUARRY_OLD]: 'building_quarry',
    
    // Iron resources and buildings
    [IRON]: 'resource_iron_node',
    [MINE]: 'building_mine',
    [FOUNDRY]: 'building_foundry',
    [MINE_OLD]: 'building_mine',
    
    // Food resources and buildings
    [FOOD]: null, // Empty/open
    [OPEN]: null,
    [FARM]: 'building_farm',
    [MILL]: 'building_mill',
    [LAKE]: 'resource_lake',
    [FARM_OLD]: 'building_farm',
    
    // Gold buildings
    [GOLD]: null,
    [MANOR]: 'building_manor',
    [BAZAAR]: 'building_bazaar',
    [WHARF]: 'building_wharf',
    
    // Infrastructure
    [CASA]: 'building_casa',
    [CELLARIUM]: 'building_cellarium',
    [CACHE]: 'building_cache',
    
    // Military buildings
    [SHIPYARD]: 'building_shipyard',
    [BARRACKS]: 'building_barracks',
    [CASTLE]: 'building_castle',
    [CITY_GUARD_HOUSE]: 'building_guard_house',
    [MOONGLOW]: 'building_moonglow',
    [STABLES]: 'building_stable',
    [TEMPLE]: 'building_temple',
    [TRAINING_GROUND]: 'building_training_ground',
    [WORKSHOP]: 'building_workshop',
};

/**
 * Get image asset key for a tile
 */
export function getTileImageKey(tile) {
    return TILE_IMAGE_MAP[tile] || null;
}

/**
 * Check if tile should render an image
 */
export function shouldRenderTile(tile) {
    return TILE_IMAGE_MAP[tile] !== null && TILE_IMAGE_MAP[tile] !== undefined;
}

